import { render, staticRenderFns } from "./OrderChangeComponents.vue?vue&type=template&id=0831538a&scoped=true&"
import script from "./OrderChangeComponents.vue?vue&type=script&lang=js&"
export * from "./OrderChangeComponents.vue?vue&type=script&lang=js&"
import style0 from "./OrderChangeComponents.vue?vue&type=style&index=0&id=0831538a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0831538a",
  null
  
)

export default component.exports